module.exports = __webpack_public_path__ + "static/media/foodpartners_bb_mobile.b04877a4.png";